import React, { useState, useEffect } from 'react';
import MarkdownMessage from './MarkdownMessage';

interface TypewriterMarkdownProps {
  text: string;
  speed?: number;
  onComplete?: () => void;
  className?: string;
}

const TypewriterMarkdown: React.FC<TypewriterMarkdownProps> = ({ 
  text, 
  speed = 30, 
  onComplete, 
  className = "" 
}) => {
  const [displayedText, setDisplayedText] = useState('');
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isComplete, setIsComplete] = useState(false);

  useEffect(() => {
    if (currentIndex < text.length) {
      const timer = setTimeout(() => {
        setDisplayedText(prev => prev + text[currentIndex]);
        setCurrentIndex(prev => prev + 1);
      }, speed);

      return () => clearTimeout(timer);
    } else {
      setIsComplete(true);
      if (onComplete) {
        onComplete();
      }
    }
  }, [currentIndex, text, speed, onComplete]);

  useEffect(() => {
    setDisplayedText('');
    setCurrentIndex(0);
    setIsComplete(false);
  }, [text]);

  return (
    <div className={className}>
      <MarkdownMessage content={displayedText} />
      {!isComplete && (
        <span className="animate-pulse text-gray-500">|</span>
      )}
    </div>
  );
};

export default TypewriterMarkdown;
